import React, { useState, useEffect } from 'react';
import '../styles/market.css';
function Market() {

  const [cryptoData, setCryptoData] = useState([]);
  const [forexData, setForexData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("crypto");
  const [isLoading, setIsLoading] = useState(true);

  // Fetch Crypto Data (using Coingecko API)
  useEffect(() => {
    const fetchCryptoData = async () => {
      try {
        const response = await fetch('https://api.coingecko.com/api/v3/coins/markets?ids=bitcoin,ethereum,solana,cardano,xrp,dogecoin,matic-network,shiba-inu,avalanche-2&vs_currency=usd');
        const data = await response.json();

        const formattedData = data.map(coin => ({
          pair: `${coin.symbol.toUpperCase()}USD`,
          lastPrice: coin.current_price,
          change: coin.price_change_percentage_24h,
          icon: coin.image
        }));

        setCryptoData(formattedData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching crypto data:', error);
        setIsLoading(false);
      }
    };

    // Fetch Forex Data (using Frankfurter API)
    const fetchForexData = async () => {
      try {
        const response = await fetch('https://api.frankfurter.app/latest?from=USD');
        const data = await response.json();
        const forexPairs = ['EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CNH', 'THB'];

        const formattedData = forexPairs.map(pair => {
          const lastPrice = data.rates[pair];

          return {
            pair: `${pair}USD`,
            lastPrice: lastPrice ? Number(lastPrice) : 0,
            change: lastPrice ? Number((Math.random() * 2 - 1).toFixed(2)) : 0,
          };
        });

        setForexData(formattedData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching forex data:', error);
        setIsLoading(false);
      }
    };

    fetchCryptoData();
    fetchForexData();

    // Refresh data every minute for real-time updates
    const interval = setInterval(() => {
      fetchCryptoData();
      fetchForexData();
    }, 60000); // Refresh every minute

    return () => clearInterval(interval);
  }, []);

  const displayedData = selectedTab === "crypto" ? cryptoData : forexData;

  return (
    <div className="List-price">
      <div className="tab-container">
        <button
          className={`tab-button ${selectedTab === "crypto" ? "active" : ""}`}
          onClick={() => setSelectedTab("crypto")}
        >
          Crypto
        </button>
        <button
          className={`tab-button ${selectedTab === "forex" ? "active" : ""}`}
          onClick={() => setSelectedTab("forex")}
        >
          Forex
        </button>
        <button
          className={`tab-button ${selectedTab === "favorite" ? "active" : ""}`}
          onClick={() => setSelectedTab("favorite")}
        >
          Favorite
        </button>
      </div>

      <div className="table-container">
        {isLoading ? (
          <p className="loading">Loading...</p>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Pair</th>
                <th style={{ color: "black", textAlign: "center" }}>Last Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {selectedTab === "favorite" ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                    No favorites added yet.
                  </td>
                </tr>
              ) : (
                displayedData.map((item) => (
                  <tr key={item.pair}>
                    <td style={{ color: "red", textAlign: "left" }}>
                      <div className="pair-container" style={{ display: "flex", alignItems: "start" }}>
                        {selectedTab === "crypto" ? (
                          <img
                            src={item.icon}
                            alt={item.pair}
                            className="pair-icon"
                            onError={(e) => {
                              console.error('Icon load error:', e);
                              e.target.src = "/icons/default.png";
                            }}
                          />
                        ) : (
                          <img
                            src={`https://flagcdn.com/w40/${item.pair.slice(0, 3).toLowerCase()}.png`}
                            alt={item.pair}
                            className="pair-icon"
                            onError={(e) => {
                              console.error('Flag load error:', e);
                              const fallbackCodes = {
                                'eur': 'eu',
                                'gbp': 'gb',
                                'jpy': 'jp',
                                'aud': 'au',
                                'cad': 'ca',
                                'cnh': 'cn',
                                'thb': 'th',
                              };
                              const code = item.pair.slice(0, 3).toLowerCase();
                              e.target.src = fallbackCodes[code]
                                ? `https://flagcdn.com/w40/${fallbackCodes[code]}.png`
                                : "/icons/default.png";
                            }}
                          />
                        )}
                        <div>{item.pair}</div>
                      </div>
                    </td>
                    <td style={{ color: "black", textAlign: "center" }}>
                      ${item.lastPrice ? item.lastPrice.toFixed(5) : "0.00000"}
                    </td>
                    <td>
                      <div
                        className={item.change < 0 ? "negative" : "positive"}
                        style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}
                      >
                        {item.change.toFixed(2)}%
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Market;